// environment/data fields
export const treebrowserow = "treebrowserow";
export const treebrowserow__icons = "treebrowserow__icons";
export const jsDraggable = "jsDraggable";
export const fieldspan = "fieldspan";
export const selected = "selected";

export const column_content = "column_content";
export const treeBrowse = "treeBrowse";
export const treeBrowseSectionHeader = "treeBrowseSectionHeader";
export const selectable = "selectable";
export const nowrap = "nowrap";
export const field = "field";

// relationship fields
export const jsOneToManyDraggable = "jsOneToManyDraggable";
export const relationship = "relationship";

// calculated fields
export const calculatedField = "calculatedField";

// treebrowselist
export const treeListItemHeader = "treeListItemHeader";
export const treebrowseHeaderCell = "treebrowse__headerCell";
export const treebrowseTreeGridTable = "treebrowse__treeGridTable";
export const jsTreebrowseTreeGridTable = "js-treebrowse__treeGridTable";

// breadcrumbs
export const breadcrumbSpan = "breadcrumbspan";
export const breadcrumbLabel = "breadcrumblabel";
export const treeBreadcrumb = "treebreadcrumb";

export const breadcrumbList = "breadcrumbList";
export const jsbreadcrumbList = "js-breadcrumbList";


